import React, { useState } from 'react';
import styled from 'styled-components';

import locations from '../constants/locations';

import useForm from '../hooks/useForm';

import { generateURLPath } from '../helpers';

import Button from './Button';

const Form = styled.form`
  align-items: center;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 9px 24px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  margin: 35px 0 15px;
  padding: 20px;
  position: sticky;
  top: 8px;

  span {
    padding: 0 18px;
    margin: 6px;
  }

  @media (max-width: 500px) {
    flex-direction: column;
    position: static;
    margin-left: 16px;
    margin-right: 16px;
  }
`;

const Select = styled.select`
  appearance: none;
  border: none;
  background: #f6f6f6;
  border-radius: ${p => p.theme.borderRadius};
  border: solid 3px transparent;
  cursor: pointer;
  font-size: 1rem;
  margin: 6px;
  padding: 0 18px;
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 5px;
  line-height: 46px;
  text-decoration-color: #ccc;
  text-decoration-thickness: 1px;

  &:hover {
    border-color: ${p => p.theme.primary600};
  }
  &:focus {
    border-color: ${p => p.theme.primary900};
    outline: none;
  }
`;

export default function SearchForm({ searchFn, filters, country = 'au' }) {
  const { values, handleChange } = useForm(filters);

  return (
    <Form
      onSubmit={ev => {
        ev.preventDefault();
        const path = generateURLPath(values);
        window.location = path;
      }}
    >
      <span>Find me</span>
      <Select onChange={handleChange} value={values['type']} name="type">
        <option value="photographer">Photographers</option>
        <option value="celebrant">Celebrants</option>
        <option value="transport-and-cars">Transport and Cars</option>
      </Select>
      <span>in</span>
      <Select
        onChange={handleChange}
        value={values['area_level_1']}
        name="area_level_1"
      >
        {locations[country].map(level1 => {
          return (
            <option value={level1.value} key={level1.value}>
              {level1.label}
            </option>
          );
        })}
      </Select>
      <Button type="primary">Go</Button>
    </Form>
  );
}
